import { AchSourceModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class AchSource extends DomainEntity<AchSourceModelDto> {
    public createDefault(): this {
        return new AchSource({
            id: 0,
            updatedDate: '',
            name: '',
            key: '',
        }) as this;
    }

    public get name() {
        return this.dto.name;
    }

    public get key() {
        return this.dto.key;
    }
}
